import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { extractDate } from "../../../Components/Functions/date.fun";

const GuestTable = ({ data, currentPage, itemsPerPage }) => {
  const tableHead = [
    "Sr.",
    "Date",
    "Guest Name",
    "Guest Podcast",
    "Contact Num",
    "Actions",
  ];

  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/guest-view/${id}`);
  };

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return (
                <>
                  <th key={index}>{item}</th>
                </>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.guestName || "N/A"}</td>
                <td>{linkifyText(item?.guestPodcast || "N/A")}</td>
              
                <td>{item?.guestContactNum || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GuestTable;
